import { Component } from "react";
import {
  setPolicyDetails,
  setDeepLinkingUrl
} from "../../actions/policy/policyActions";
import { connect } from "react-redux";
import { Paths } from "../../constants/UrlConstants";
import SystemUnavailability from "../../services/SystemUnavailabilityService";

export const mapStateToProps = state => {
  return {
    isPolicyDetailsPresent: !!(
      state &&
      state.policyReducer &&
      state.policyReducer.policyDetails
    ),
    isSelectedPolicyPresent: !!(
      state &&
      state.policyReducer &&
      state.policyReducer.selectedPolicy
    ),
    isTimedOut:
      state && state.accountReducer && state.accountReducer.isTimedOut,
    systemUnavailable:
      state &&
      state.networkStateReducer &&
      state.networkStateReducer.systemUnavailable
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setPolicyDetails: history => dispatch(setPolicyDetails(history)),
    setDeepLinkingUrl: url => dispatch(setDeepLinkingUrl(url))
  };
};

function callSetPolicyDetails() {
  if (
    this.props.isPolicyDetailsRequired &&
    !this.props.isPolicyDetailsPresent &&
    !this.props.isTimedOut &&
    !this.isLoading
  ) {
    this.isLoading = true;
    this.props
      .setPolicyDetails(this.props.history)
      .then(() => (this.isLoading = false));
  }

  if (
    !this.isLoading &&
    !this.props.systemUnavailable &&
    this.props.systemAvailabilityCheck
  ) {
    this.isLoading = true;
    SystemUnavailability()
      .then(() => (this.isLoading = false))
      .catch(() => (this.isLoading = false));
  }
}

class PolicyRequired extends Component {
  componentDidMount() {
    if (
      this.props.isPolicyDetailsRequired &&
      this.props.history &&
      this.props.history.location &&
      this.props.history.location.pathname &&
      this.props.history.location.pathname !== Paths.HomeRoot &&
      this.props.history.location.pathname.localeCompare(
        Paths.ChooseYourPlan,
        undefined,
        {
          sensitivity: "accent"
        }
      ) !== 0
    ) {
      this.props.setDeepLinkingUrl(this.props.history.location.pathname);
    }

    callSetPolicyDetails.apply(this);
  }

  componentDidUpdate() {
    callSetPolicyDetails.apply(this);
  }

  render() {
    return this.props.children
      ? this.props.isPolicyDetailsRequired &&
        this.props.isPolicyDetailsPresent &&
        (this.props.isSelectedPolicyPresent ||
          this.props.selectedPolicyNotRequired)
        ? this.props.children
        : !this.props.isPolicyDetailsRequired
        ? this.props.children
        : null
      : null;
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PolicyRequired);
